<div class="accordion-card grey-border">
  <div ngbAccordion class="d-flex flex-column">
    <div class="d-flex" (click)="headerClicked()">
      <div class="chevron-container me-2">
        <img
          class="chevron"
          [src]="'assets/icons/grey/Chevron Up.svg'"
          [class.expanded]="!isCollapsed"
          [class.collapsed]="isCollapsed"
          alt="chevron"
          i18n-alt />
      </div>
      <div class="contribution-card-title" i18n>Defined Contribution Accounts</div>
    </div>
    <div [collapsed]="isCollapsed" class="border-0" ngbAccordionItem>
      <div ngbAccordionCollapse>
        <div
          class="account-item"
          *ngFor="let account of accounts; let first = first"
          [style.padding-top.rem]="first ? 1.5 : 0.5">
          <div class="account-info">
            <span class="account-name">{{ account.employerName }}</span>
            <span class="account-id">{{ account.accountId }}</span>
          </div>
          <div class="view-account">
            <button class="link-button no-style-button view-account-button" (click)="goToAccount(account.accountId)">
              <img [src]="'assets/icons/primary/External Link.svg'" alt="" />
              <span i18n>View Account</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
